import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
import { loadFeatureFlags } from './config';
/**
 * Feature flags context
 */
const FeatureFlagsContext = createContext(null);
/**
 * Feature flags provider component
 * Provides feature flags to the entire application via React context
 */
export function FeatureFlagsProvider({ children, flags: overrideFlags }) {
    // Load flags from environment or use override
    const flags = overrideFlags ? { ...loadFeatureFlags(), ...overrideFlags } : loadFeatureFlags();
    return _jsx(FeatureFlagsContext.Provider, { value: flags, children: children });
}
/**
 * Hook to access all feature flags
 * @throws Error if used outside of FeatureFlagsProvider
 */
export function useFeatureFlags() {
    const context = useContext(FeatureFlagsContext);
    if (context === null) {
        throw new Error('useFeatureFlags must be used within FeatureFlagsProvider');
    }
    return context;
}
/**
 * Hook to check if a specific feature is enabled
 * @param flagName - The name of the feature flag to check
 * @returns boolean indicating if the feature is enabled
 */
export function useFeatureFlag(flagName) {
    const flags = useFeatureFlags();
    return flags[flagName];
}
/**
 * Hook to get multiple feature flags at once
 * @param flagNames - Array of feature flag names to check
 * @returns Object with flag names as keys and their enabled state as values
 */
export function useFeatureFlags_Multiple(flagNames) {
    const flags = useFeatureFlags();
    return flagNames.reduce((acc, flagName) => {
        acc[flagName] = flags[flagName];
        return acc;
    }, {});
}
